import {create, StateCreator} from 'zustand'
import {devtools} from 'zustand/middleware'

import createAuthSlice, {AuthSlice} from 'modules/auth/store'
import createUsersSlice, {UsersSlice} from 'modules/users/store'
import createRequestsSlice, {RequestsSlice} from 'modules/request/store'
import createProjectsSlice, {ProjectsSlice} from 'modules/projects/store'
import createProjectSlice, {ProjectSlice} from 'modules/project/store'
import createProfileSlice, {ProfileSlice} from 'modules/profile/store'
// import createOrgsSlice, { OrgsSlice } from 'modules/organisations/store'

export type State = AuthSlice &
  UsersSlice & 
  RequestsSlice &
  ProjectsSlice &
  ProjectSlice &
  ProfileSlice
  // OrgsSlice &

export type CreateSlice<T> = StateCreator<State, [], [], T>

const useStore = create<State>()(
  devtools((...a) => ({
    ...createAuthSlice(...a),
    ...createUsersSlice(...a),
    ...createRequestsSlice(...a),
    ...createProjectsSlice(...a),
    ...createProjectSlice(...a),
    ...createProfileSlice(...a),
    // ...createOrgsSlice(...a),
  }))
)

export default useStore
